/**
 * SaaS module access — prototype TV_SAAS.navAccess (free / paid / admin / team).
 */

export const SAAS_FEATURE_GATE = Object.freeze({
  free: "free",
  paid: "paid",
  admin: "admin",
  team: "team",
});

export function resolveSaasFeatureAccess({
  gate = SAAS_FEATURE_GATE.free,
  entitlements = {},
  role,
} = {}) {
  const isPremium = Boolean(entitlements.isPremium || entitlements.isEnterprise);
  const normalizedRole = String(role || "").toLowerCase();
  const isAdmin = normalizedRole === "admin" || normalizedRole === "superadmin";

  if (!gate || gate === SAAS_FEATURE_GATE.free) {
    return { unlocked: true, badge: null, cta: null };
  }

  if (gate === SAAS_FEATURE_GATE.paid || gate === "premium" || gate === "growth") {
    return {
      unlocked: isPremium,
      badge: "Premium",
      cta: isPremium ? null : "buyCredits",
    };
  }

  if (gate === SAAS_FEATURE_GATE.admin) {
    return { unlocked: isAdmin, badge: "Admin", cta: null };
  }

  if (gate === SAAS_FEATURE_GATE.team) {
    return {
      unlocked: isPremium,
      badge: "Admin",
      cta: isPremium ? null : "home",
    };
  }

  return { unlocked: true, badge: null, cta: null };
}
